import { isValidEmailAddress } from '../functions';
//import Swal from 'sweetalert2';

$(document).ready(function() {
    const wishlist = {
        isLoading: false,
        init() {
            $(document).on('click', '.add-to-favorite-btn', this, this.save);
        },
        save(event) {
            event.preventDefault();
            event.stopImmediatePropagation();
            const _this = event.data;
			let element = this;

            if (_this.isLoading) {
                return false;
            }

            //Loading...
            _this.isLoading = true;
			$(element).append('<i class="fa fa-spinner fa-spin" style="margin-right: 20px"></i>');

            var values = '_token=' + $('#_token_add_wishlist').val();
            values += '&id=' + $(element).data('id');
            $.ajax({
                type: "POST",
                url: `${baseURL}/product/wishlist/save`,
                data: values,
                success: function(response) {
                    _this.isLoading = false;
                    $(element).find('i').remove();

                    if (response.status == 0) {
						Swal.fire({
							icon: 'error',
							title: 'Oops...',
							text: response.message
						});
                        return false;
                    }

                    if (response.status == 1) {
						$(element).addClass('active');
						Swal.fire({
							icon: 'success',
							title: 'Success...',
							text: response.message
						});
                        return false;
                    }

					Swal.fire({
						icon: 'error',
						title: 'Oops...',
						text: response.message
					});
                },
                error(error) {
                    _this.isLoading = false;
                    $(element).find('i').remove();
                }
            });
        }

    };

    if ($('.add-to-favorite-btn').length) {
        wishlist.init();
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/wishlist.js